<!-- Based on this Block: https://bl.ocks.org/SpaceActuary/d6b5ca8e5fb17842d652d0de21e88a05 -->

<script>
    import { onMount, afterUpdate } from 'svelte';
    import * as d3 from "d3";
    import { attr } from 'svelte/internal';
    import { createEventDispatcher } from 'svelte';
    
    // create event dispatcher event, which will send data up to App
    const dispatch = createEventDispatcher();
    const triggerEvent = (d) => {
        dispatch("bubHover", d);
    }

	// props are updated whenever the prop value changes...
    export let current;
    export let dataset;
    export let w;
    export let rootid;

    let margin = {
        top: 10,
        bottom: 10,
        right: w/10,
        left: w/10
    }

    let svg;
    let bubblesWidth;
    let h = 350;
    let centerScale;
    let rOffset;
    let rScale = d3.scaleLinear().domain([100,600]).range([5,35]);

    onMount(() => {
        
        // d3.select("#"+rootid+"-svg").remove() // override duplicate svg append
        bubblesWidth = w-margin.left-margin.right
        centerScale = d3.scaleOrdinal().range([margin.left, w-margin.right]);
        splitBubbles(current)
	})
    
    afterUpdate(() => {
        // fires every time width changes
        bubblesWidth = w-margin.left-margin.right
        d3.select("#"+rootid+"-svg").attr("width", w).attr("height", h)
        centerScale = d3.scaleBand().range([margin.left, w-margin.right]).padding(0.5);
        g.selectAll('.legend-items').remove(); // clear the legend labels before redrawing
        svg.selectAll('.circle-legend').remove()
        drawCircleLegend();
        splitBubbles(current)
        if (w < 600) { // mobile settings
            rScale.range([2,20])

            g.selectAll("circle")
                .data(dataset, (d)=>{ return d.title ;})
                .attr("r", (d) => { return rScale(d.pages)})

                simulation.force("collide",d3.forceCollide( (d)=>{
            return (d.r) - 0 }).iterations(2) 
        )
            
        } else { // desktop settings
            rScale.range([5,35])

            g.selectAll("circle")
                .data(dataset, (d)=>{ return d.title ;})
                .attr("r", (d) => { return rScale(d.pages)})

            simulation.alpha(0.5).restart();
        }
    })

    function sortByMonth(arr) {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        arr.sort(function(a, b){
            return months.indexOf(a.month)
                - months.indexOf(b.month);
        });
    }

    function mouseover(e,d) {
        d3.select(this)
            .style("stroke-width", 3)
        
        svg.append("text")
            .attr("x", e.offsetX)
            .attr("y", e.offsetY-20)
            .style("opacity", 0)
            .style("paint-order", "stroke")
            .style("stroke", "white")
            .style("stroke-width", 3)
            .style("stroke-linecap", "butt")
            .style("stroke-linejoin", "miter")
            .text(d.title)
            .transition()
                      .duration(100) // ms
                      .style("opacity", .9) 
            .attr("class", "name-tooltip")
    }

    function bubClick(d,i) {
        triggerEvent(i);
        // tooltip info is inside of i
    }

    function mouseout() {
        d3.selectAll("circle")
            .style("stroke-width", 2)

        d3.selectAll('.name-tooltip')
        .transition()
        .duration(100) // ms
        .style("opacity", 0) 
            .remove()
    }

    svg = d3.select("#"+rootid).append("svg")
            .attr("width", w)
            .attr("height", h)
            .attr("id", rootid+"-svg")

    let g = d3.select("#"+rootid+"-svg").append("g").attr("transform", "translate("+margin.left+",0)");
    
    const color = d3.scaleOrdinal(d3.schemeAccent)
        .range([ "#00A8A7", "#F2BC51","#9AD3DA", "#FF904B", "#03454A", "#9C1B44","#BA9987", "#D36451"]);
    
    let forceStrength = 0.065

    var simulation = d3.forceSimulation()
        .force("collide",d3.forceCollide( (d)=>{
            return d.r + 2 }).iterations(20) 
        )
        .force("charge", d3.forceManyBody())
        .force("y", d3.forceY().y(h/2))
        .force("x", d3.forceX().x((w-margin.right-margin.left) / 2))

    dataset.forEach(function(d){
        d.r = rScale(d.pages);
        d.x = (bubblesWidth) / 2;
        d.y = h / 2;
      })
      
    var circles = g.selectAll("circle")
        .data(dataset, (d)=>{ return d.title ;});
          
    var circlesEnter = circles.enter().append("circle")
      	.attr("r", (d)=>{ return d.r; })
        .attr("cx", ()=>{ return 45})
        .attr("cy", ()=>{ return 250; })
      	.style("fill", (d)=>{ 
              return color(d.genre); 
            })
      	.style("stroke", "black")
      	.style("stroke-width", 2)
          .style("pointer-events", "all")
          .on("mouseover", mouseover)
          .on("mouseout", mouseout)
          .on("click", bubClick)
    
      circles = circles.merge(circlesEnter);

      function ticked() {
        //console.log(data.map(function(d){ return d.x; }));
        circles
            .attr("cx", (d)=>{ return d.x; })
            .attr("cy", (d)=>{ return d.y; });
      }   

      simulation
            .nodes(dataset)
            .on("tick", ticked);
      
      function splitBubbles(byVar) {
        
        if(byVar == "all"){
          hideTitles()
          g.attr("transform", "translate("+margin.left+",0)")
          simulation.force('x', d3.forceX().strength(forceStrength).x((d)=>{ 
                return bubblesWidth / 2;
            }));
        } else {
            // if blocks to apply correct data sorting byVar
            if (byVar == "rating") {
                dataset.sort(function(a,b) { return +a.rating - +b.rating })
        
                centerScale.domain(dataset.map((d)=>{ return d[byVar]; }));
            } else if (byVar == "month") {
                sortByMonth(dataset)

                centerScale.domain(dataset.map((d)=>{ return d[byVar]; }));
            } else {
                centerScale.domain(dataset.map((d)=>{ return d[byVar]; }));
            }

            // readjust the transform so bubs stay in mid of page
            g.attr("transform", "translate("-margin.left+",0)")

            showTitles(byVar, centerScale);
        
            // @v4 Reset the 'x' force to draw the bubbles to their year centers
            simulation.force('x', d3.forceX().strength(forceStrength).x((d) => { 
                return centerScale(d[byVar]);
            }));
        }

        // @v4 We can reset the alpha value and restart the simulation
        simulation.alpha(0.5).restart();
      }
      
      function hideTitles() {
        g.selectAll('.title').remove();
        g.selectAll('.legend-items').remove();
      }

      function showTitles(byVar, scale) {
        // Another way to do this would be to create
        // the year texts once and then just hide them.
       	var titles = g.selectAll('.title')
          .data(scale.domain());

        if (byVar == "genre") {
            g.selectAll('.legend-items')
                .data(scale.domain())
                .enter().append('rect')
                .attr('x',(d)=> { 
                    return scale(d) - 10; 
                })
                .attr('y',50)
                .attr('width',20)
                .attr('height',5)
                .attr('fill', (d)=> {
                    return color(d)
                })
                .attr('class', 'legend-items')
                
        }
        
        titles.enter().append('text')
          	.attr('class', 'title')
            .merge(titles)
            .attr('x', (d)=> { return scale(d); })
            .attr('y', 40)
            .attr('text-anchor', 'middle')
            .text((d)=> { return d; });
        
        titles.exit().remove() 
      }

      function drawCircleLegend() {
        if (current != "intro") {

        svg.selectAll('.circle-legend').remove()
            // add circle size legend
        svg.append('circle')
                .attr('cx', w - 100)
                .attr('cy', h-40)
                .attr('r', 30)
                .attr('stroke', 'gray')
                .attr('fill', 'none')
                .attr('class', 'circle-legend')

            svg.append('circle')
                .attr('cx', w - 100)
                .attr('cy', h-50)
                .attr('r', 20)
                .attr('stroke', 'gray')
                .attr('fill', 'none')
                .attr('class', 'circle-legend')

            svg.append('circle')
                .attr('cx', w - 100)
                .attr('cy', h-60)
                .attr('r', 10)
                .attr('stroke', 'gray')
                .attr('fill', 'none')
                .attr('class', 'circle-legend')

            svg.append('text')
                .attr('x', w - 100)
                .attr('y', h-85)
                .attr('font-size', 12)
                .attr('fill', 'gray')
                .attr('text-anchor', 'middle')
                .attr('class', 'circle-legend')
                .text('# of pages')

            svg.append('text')
                .attr('x', w - 100)
                .attr('y', h-57)
                .attr('font-size', 10)
                .attr('fill', 'gray')
                .attr('text-anchor', 'middle')
                .attr('class', 'circle-legend')
                .text('80')

            svg.append('text')
                .attr('x', w - 100)
                .attr('y', h-37)
                .attr('font-size', 10)
                .attr('fill', 'gray')
                .attr('text-anchor', 'middle')
                .attr('class', 'circle-legend')
                .text('300')

            svg.append('text')
                .attr('x', w - 100)
                .attr('y', h-17)
                .attr('font-size', 10)
                .attr('fill', 'gray')
                .attr('text-anchor', 'middle')
                .attr('class', 'circle-legend')
                .text('700')
        }
    }
    
</script>

<p>
    {#if current != "intro"}
        {#if current == "all"}
        <span>All</span>
        {:else}
            Books by <span>{current}</span>
        {/if}
    {/if}
</p>

<style>
	span {
		display: inline-block;
		padding: 0.2em 0.5em;
		margin: 0 0.2em 0.2em 0;
		width: 4em;
		text-align: center;
		border-radius: 0.2em;
		color: black;
        background-color: bisque;
	}
</style>